
import "./EUMRVPortStays.scss";
import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	DerogationOMRColumns,
	EUMRV_PORTSTAYS_HEADERS,
	ETS_COLUMN_KEYS,
	MRV_COLUMN_KEYS
} from "../../../../../../constants/CustomTableHeaders";


const DerogationOMR = ({ data }) => {
	
		const columnsData = (() => {
			const idsToExclude =  MRV_COLUMN_KEYS ;
			return DerogationOMRColumns.filter((col) => !idsToExclude.includes(col.accessorKey));
		})();
	
	return (
		<div className="mt-4 eu_mrv_ps">
			<CustomTable
				columnsData={columnsData}
				renderTableData={data || []} // Replace with actual data
				customProps={{
					header: EUMRV_PORTSTAYS_HEADERS.OMR,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default DerogationOMR;
